import types from '../mutation-types';
import SocialResponseTemplatesAPI from '../../api/socialResponseTemplates';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getTemplates(_state) {
    return _state.records;
  },
  getTemplatesByInbox: _state => inboxId => {
    return _state.records.filter(
      t => t.inbox_id === null || t.inbox_id === Number(inboxId)
    );
  },
};

export const actions = {
  get: async ({ commit }, { inboxId } = {}) => {
    commit(types.SET_SOCIAL_RESPONSE_TEMPLATES_UI_FLAG, { isFetching: true });
    try {
      const response = inboxId
        ? await SocialResponseTemplatesAPI.getByInbox(inboxId)
        : await SocialResponseTemplatesAPI.get();
      commit(types.SET_SOCIAL_RESPONSE_TEMPLATES, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SOCIAL_RESPONSE_TEMPLATES_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_SOCIAL_RESPONSE_TEMPLATES_UI_FLAG, { isCreating: true });
    try {
      const response = await SocialResponseTemplatesAPI.create({
        social_response_template: data,
      });
      commit(types.ADD_SOCIAL_RESPONSE_TEMPLATE, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SOCIAL_RESPONSE_TEMPLATES_UI_FLAG, {
        isCreating: false,
      });
    }
  },
  update: async ({ commit }, { id, ...data }) => {
    commit(types.SET_SOCIAL_RESPONSE_TEMPLATES_UI_FLAG, { isUpdating: true });
    try {
      const response = await SocialResponseTemplatesAPI.update(id, {
        social_response_template: data,
      });
      commit(types.EDIT_SOCIAL_RESPONSE_TEMPLATE, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SOCIAL_RESPONSE_TEMPLATES_UI_FLAG, {
        isUpdating: false,
      });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_SOCIAL_RESPONSE_TEMPLATES_UI_FLAG, { isDeleting: true });
    try {
      await SocialResponseTemplatesAPI.delete(id);
      commit(types.DELETE_SOCIAL_RESPONSE_TEMPLATE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SOCIAL_RESPONSE_TEMPLATES_UI_FLAG, {
        isDeleting: false,
      });
    }
  },
};

export const mutations = {
  [types.SET_SOCIAL_RESPONSE_TEMPLATES_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_SOCIAL_RESPONSE_TEMPLATES](_state, data) {
    _state.records = data;
  },
  [types.ADD_SOCIAL_RESPONSE_TEMPLATE](_state, data) {
    _state.records.push(data);
  },
  [types.EDIT_SOCIAL_RESPONSE_TEMPLATE](_state, data) {
    const index = _state.records.findIndex(c => c.id === data.id);
    if (index !== -1) {
      _state.records.splice(index, 1, data);
    }
  },
  [types.DELETE_SOCIAL_RESPONSE_TEMPLATE](_state, id) {
    _state.records = _state.records.filter(c => c.id !== id);
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
